export default __webpack_public_path__ + "static/media/gallery_01.01cbfc51.jpg";